<template>
  <div>
      <b-form-group id="input-group-var-1" label="Tipus SAD:" label-size="sm" label-for="input-var-1"  label-cols="4" label-cols-lg="2">
        <b-form-select required size="sm" id="input-var-1" v-model="tipusSad" :options="opcionsTipusSad" @input="onUpdateTipusSad">
           <template v-slot:first>
            <b-form-select-option :value="null">Tots</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
  </div>
</template>

<script>
export default {
  name: "VariableTipusSad",
  props: {
    initialValue:{      
      required: true
    }
  },  
  data() {
    return {
      codiVariable: 'tipus-sad',
      tipusSad: null,
      opcionsTipusSad: [
          { value: 'P', text: 'Preventiu' },
          { value: 'D', text: 'Dependència' }
      ]
    };
  },
  computed:{
    returnValue(){
      let r = {codi: this.codiVariable}
      if(this.tipusSad!=null ){
        r.valor = this.tipusSad;
      }

      return r;
    }
  },    
  methods: {    
    onUpdateTipusSad(newValue){      
      console.log(newValue)
      if(this.returnValue.valor){
        this.$emit('variable-editada', this.returnValue)        
      }else{
        this.$emit('variable-eliminada', this.codiVariable)        
      }      
    }
  },
  mounted() {
    if(this.initialValue!=null){
      this.tipusSad = this.initialValue.valor}
    }
};
</script>

<style>
#input-var-1{
  width: 180px;
}
</style>